import Chatbot, { createChatBotMessage } from 'react-chatbot-kit';
import Markdown from 'react-markdown';
import IConfig from 'react-chatbot-kit/build/src/interfaces/IConfig';

import { useMemo } from 'react';
import { useAuth } from '@/shared/context/AuthProvider';
import { TaskWidget } from './widgets/TaskWidget';

import MessageParser from './MessageParser';
import ActionProvider from './ActionProvider';

import './BuildingChat.module.css';
import { ActionItem } from '@urbanmix-tech/shared-js';
import { WithId } from '../BuildingWorkflows/BuildingWorkflows';

interface BuilindChatProps {
  projectId: string;
  buildingId: number;
  onClickActionItem(actionItem: ActionItem): void;
  handleOpenActionItemById(obj: WithId): void;
}

const BuildingChat = ({
  projectId,
  buildingId,
  onClickActionItem,
}: BuilindChatProps) => {
  const sessionId = useMemo(() => {
    return Math.random().toString(36).substring(7);
  }, []);

  const { userData } = useAuth();

  const config: IConfig = {
    initialMessages: [
      createChatBotMessage(
        `Let me know how I can help you today. I can create leases, or answer questions about the building or units.`,
        {}
      ),
    ],
    botName: 'Ezra',
    customComponents: {
      header: () => <div />,
      botAvatar: () => <div />,
      botChatMessage: (props: any) => (
        <Markdown className="popup-markdown">{props.message}</Markdown>
      ),
      // userAvatar: (props : any) => (<p>USER</p>),
    },
    widgets: [
      {
        widgetName: 'taskWidget',
        widgetFunc: (props: any) => <TaskWidget {...props} />,
        mapStateToProps: [],
        props: { onClickActionItem },
      },
    ],
  };

  const finalConfig = {
    ...config,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    state: {
      ...config.state,
      sessionId,
      user: userData?.email,
      projectId,
      buildingId,
      onClickActionItem,
    },
  };

  return (
    <div className="chatbotcontainer flex h-[calc(100vh-115px)] flex-col justify-end px-[15px] pt-[15px]">
      <Chatbot
        config={finalConfig}
        messageParser={MessageParser}
        actionProvider={ActionProvider}
      />
    </div>
  );
};

export default BuildingChat;
